export { ConfirmedDialogComponent } from './confirmed-dialog/confirmed-dialog.component';